var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAouCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_566_922",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_566_922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 11.0623L6.58346 14.479C6.43068 14.6318 6.25707 14.7047 6.06263 14.6978C5.86818 14.6908 5.69457 14.6109 5.54179 14.4582C5.38902 14.3054 5.31263 14.1283 5.31263 13.9269C5.31263 13.7255 5.38902 13.5484 5.54179 13.3957L8.93763 9.99984L5.52096 6.58317C5.36818 6.43039 5.29527 6.25331 5.30221 6.05192C5.30916 5.85053 5.38902 5.67345 5.54179 5.52067C5.69457 5.36789 5.87166 5.2915 6.07304 5.2915C6.27443 5.2915 6.45152 5.36789 6.60429 5.52067L10.0001 8.93734L13.4168 5.52067C13.5696 5.36789 13.7467 5.2915 13.948 5.2915C14.1494 5.2915 14.3265 5.36789 14.4793 5.52067C14.6321 5.67345 14.7085 5.85053 14.7085 6.05192C14.7085 6.25331 14.6321 6.43039 14.4793 6.58317L11.0626 9.99984L14.4793 13.4165C14.6321 13.5693 14.7085 13.7429 14.7085 13.9373C14.7085 14.1318 14.6321 14.3054 14.4793 14.4582C14.3265 14.6109 14.1494 14.6873 13.948 14.6873C13.7467 14.6873 13.5696 14.6109 13.4168 14.4582L10.0001 11.0623Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAouCloseIcon);
export default __webpack_public_path__ + "static/media/aou-close-icon.f2659888fe0725346054f1871e0eb1cb.svg";
export { ForwardRef as ReactComponent };